export default "__VITE_ASSET__DwoaKmju__"